/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__generated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Am ${i.date} auf ViaMichelin erstellt`
};

const en_route_details__expense_note_section__generated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Generated on ViaMichelin on ${i.date}`
};

const es_route_details__expense_note_section__generated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Generado por ViaMichelin, el ${i.date}`
};

const fr_route_details__expense_note_section__generated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Générée sur ViaMichelin le ${i.date}`
};

const it_route_details__expense_note_section__generated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Generata su ViaMichelin il ${i.date}`
};

const nl_route_details__expense_note_section__generated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Gegenereerd op ViaMichelin op ${i.date}`
};

const pt_route_details__expense_note_section__generated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Gerado no ViaMichelin em ${i.date}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ date: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__generated_on = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__generated_on(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__generated_on", locale)
	if (locale === "de") return de_route_details__expense_note_section__generated_on(inputs)
	if (locale === "en") return en_route_details__expense_note_section__generated_on(inputs)
	if (locale === "es") return es_route_details__expense_note_section__generated_on(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__generated_on(inputs)
	if (locale === "it") return it_route_details__expense_note_section__generated_on(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__generated_on(inputs)
	return pt_route_details__expense_note_section__generated_on(inputs)
};